import { camelize } from 'casing'
import { API } from '../../../common/api'
import { labravAWSEngineServiceUrl } from '../../../common/utils/constants'

export type ContactDetailsEngagedWith = {
  email?: string
  name?: string
}

export type ContactDetailsContact = {
  contactId: string
  contactName: string
  title?: string
  location?: string | null
  profileImageUrl?: string
  engagedWith?: ContactDetailsEngagedWith[]
}

export type ContactDetailsResponse = {
  contacts: ContactDetailsContact[]
}

export const fetchPartnerContactsDetails = (partnerId: string) =>
  API.get(
    `${labravAWSEngineServiceUrl}/partners/${partnerId}/contacts/details`
  ).then(response => ({
    ...response,
    data: camelize(response.data ?? {}) as ContactDetailsResponse,
  }))
